import {Component}                     from '@angular/core';
import {ApDynGridColumnConfigBase}     from '../../ap-dyngrids/config/ap-dyn-grid-column-config-base';
import {ApDynGridPagerConfigBase}      from '../../ap-dyngrids/config/ap-dyn-grid-pager-config-base';
import {FormStore}                     from '../../stores/layout/form.store';
import {ApDynGridPropertyColumnConfig} from '../../ap-dyngrids/config/ap-dyn-grid-property-column-config';
import {ApDynGridEditColumnConfig}     from '../../ap-dyngrids/config/ap-dyn-grid-edit-column-config';
import {ApDynGridPagerConfig}          from '../../ap-dyngrids/config/ap-dyn-grid-pager-config';
import {MapViewStore}                  from '../../stores/layout/mapview.store';
import {RouterStore}                   from '../../stores/router/router.store';

// import {routes}                        from '../ap-reports.routes';

interface IReportOverviewGridData {
  Id: number;
  Name: string;
  Description: string;
  Path: string;
}

@Component({
  selector: 'ap-reports-overview',
  template: `
    <ap-dyncomponent [caption]="'Reports'"
                     [canSearch]="true"
                     [canCreate]="false"
                     [columns]="columns"
                     [headerIcon]="'ap-basedata-icon'"
                     [items]="items"
                     [pager]="pager"
                     (edit)="showReport($event)"></ap-dyncomponent>
  `,
})

export class ApReportsOverviewComponent {

  public reportVisible = false;
  public subscriptions = [];
  public columns: ApDynGridColumnConfigBase[];
  public items: IReportOverviewGridData[];
  public pager: ApDynGridPagerConfigBase;

  constructor(private formStore: FormStore,
              private mapViewStore: MapViewStore,
              private routerStore: RouterStore) {
    this.mapViewStore.hideMapView();
    this.buildGrid();
    this.items = [
      {
        Id: 0,
        Name: 'TaskMananagement Report',
        Description: 'Report für den Export eines Auftrags',
        Path: 'task-management-report'
      }
    ];
  }

  buildGrid(): void {
    this.columns = [
      new ApDynGridPropertyColumnConfig({
        field: 'Name',
        width: 250,
        headerFilterable: true,
        filterable: true,
        title: 'Global__Name'
      }),
      new ApDynGridPropertyColumnConfig({
        field: 'Description',
        headerFilterable: true,
        filterable: true,
        title: 'Global__Description'
      }),
      new ApDynGridEditColumnConfig({})
    ];
    this.pager = new ApDynGridPagerConfig({});
  }

  /**
   * Handler for showing report previews
   */
  public showReport(dataItem: IReportOverviewGridData): void {
    this.routerStore.navigate(['administration/reports/' + dataItem.Path]);
  }
}
